var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.navigation),function(ref){
var title = ref.title;
var text = ref.text;
return _c('nuxt-link',{key:title,staticClass:"link",attrs:{"to":_vm.localePath(text) || ''}},[_vm._v("\n    "+_vm._s(title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }